import { useState } from 'react';

function useCurrentYear(): number {
  const [year, setYear] = useState(new Date().getFullYear());
  setInterval(() => setYear(new Date().getFullYear()), 1000 * 60);
  return year;
}

export default useCurrentYear;
